export const GET_DEALER_LISTINGS_REQUEST = 'GET_DEALER_LISTINGS_REQUEST';
export const GET_DEALER_LISTINGS_SUCCESS = 'GET_DEALER_LISTINGS_SUCCESS';
export const CACHE_DEALER_LISTINGS = 'CACHE_DEALER_LISTINGS';
export const CLEAR_LISTINGS_CACHE = 'CLEAR_LISTINGS_CACHE';
export const APPLY_CACHED_DEALER_LISTINGS = 'APPLY_CACHED_DEALER_LISTINGS';
export const GET_DEALER_LISTINGS_FAILURE = 'DEALER_LISTINGS_FAILURE';
export const DEALER_LISTING_TOGGLE_REQUEST = 'DEALER_LISTING_TOGGLE_REQUEST';
export const DEALER_LISTING_TOGGLE_SUCCESS = 'DEALER_LISTING_TOGGLE_SUCCESS';
export const DEALER_LISTING_TOGGLE_FAILURE = 'DEALER_LISTING_TOGGLE_FAILURE';

export const SET_FILTERS = 'DEALER_SET_FILTERS';
export const CLEAR_DEALER_FILTERS = 'CLEAR_DEALER_FILTERS';
export const RESET_LISTINGS = 'RESET_LISTINGS';
export const ERROR = 'DEALER_ERROR';

export const START_CACHE_CLEAR_TASK = 'START_CACHE_CLEAR_TASK';
export const STOP_CACHE_CLEAR_TASK = 'STOP_CACHE_CLEAR_TASK';
export const CACHE_CLEAR_TASK_CANCELLATION = 'CACHE_CLEAR_TASK_CANCELLATION';

// FEATURE NAME
export const LISTINGS_FEATURE = 'LISTINGS';
